export const SESSION_PERSISTENCE = 1000 * 60 * 60 * 24 * 30 * 3; //3 months

export const EMAIL_REGX =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const PASSWORD_REGX = /((?=.{8,})(?=.*[A-Z]))/;
